<template>
  <div class="list-container row">
    <theme-preview-two-step :sellable="sellable" v-if="config.steps === 2" ref="preview" :config="config" />
    <theme-preview-three-step :sellable="sellable" v-if="config.steps === 3" ref="preview" :config="config" />
  </div>
</template>

<script>
import { getSellable } from '../../../../../js/services/integrations-internas/supercheckout';
import ThemePreviewTwoStep from './ThemePreviewTwoStep';
import ThemePreviewThreeStep from './ThemePreviewThreeStep';

export default {
  props: ['config'],
  components: { ThemePreviewTwoStep, ThemePreviewThreeStep },
  data() {
    return {
      sellable: {}
    };
  },

  mounted() {
    getSellable(this.config.type, this.config.sellableHash).then(res => {
      this.sellable = res.data.productversion;
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/editor/apps/Checkout/Form/CheckoutThemeSelector.vue